import {
  TransferScheduleAction,
  TimeSlotData,
  TimeSlot as FormattedTimeSlot,
  TimeWindow as FormattedTimeWindow
} from './transferSchedule.types';
import {
  getTransferScheduleTimeslots,
  declineVinEtching as declineVinEtchingApi
} from '../../services';
import { formatTimeSlots, formatTimeWindows } from '../../utils/transferScheduleFormatters';

export const setDataLoaded = (
  dispatch: React.Dispatch<TransferScheduleAction>,
  dataLoaded: boolean
) => {
  dispatch({
    type: 'SET_DATA_LOADED',
    payload: { dataLoaded }
  });
};

export interface LoadTimeSlotsResult {
  timeSlots: FormattedTimeSlot[];
  timeWindows: FormattedTimeWindow[];
  isFlexibleDelivery: boolean;
  metadata: {
    first_time_slot_available: string;
    delivery_type: string;
    vin_etching_applied: string;
  };
}

export const loadTimeSlots = async (
  dispatch: React.Dispatch<TransferScheduleAction>
): Promise<LoadTimeSlotsResult | undefined> => {
  try {
    const data = await getTransferScheduleTimeslots();

    const formattedTimeSlots = formatTimeSlots(data.timeSlots || []);
    const formattedTimeWindows = formatTimeWindows(data.timeWindows || []);
    const vinEtchingState = data.vinEtchingState || '';

    dispatch({
      type: 'SET_TIME_SLOTS',
      payload: {
        timeSlots: formattedTimeSlots,
        timeWindows: formattedTimeWindows,
        isFlexibleDelivery: data.displayTimeWindows || false,
        vinEtchingState
      }
    });

    if (formattedTimeSlots.length > 0 && formattedTimeSlots[0].times.length > 0) {
      const firstTimeSlot = data.timeSlots[0];
      const firstTimeSlotDate = formattedTimeSlots[0];
      const firstTimeSlotTime = firstTimeSlotDate.times[0];

      return {
        timeSlots: formattedTimeSlots,
        timeWindows: formattedTimeWindows,
        isFlexibleDelivery: data.displayTimeWindows || false,
        metadata: {
          first_time_slot_available: `${firstTimeSlotDate.date} ${firstTimeSlotTime.time}`,
          delivery_type: firstTimeSlot.activityType.toLowerCase(),
          vin_etching_applied: vinEtchingState
        }
      };
    }

    if (formattedTimeWindows.length > 0 && formattedTimeWindows[0].times.length > 0) {
      const firstTimeWindow = data.timeWindows[0];
      const firstTimeWindowDate = formattedTimeWindows[0];
      const firstTimeWindowTime = firstTimeWindowDate.times[0];

      return {
        timeSlots: formattedTimeSlots,
        timeWindows: formattedTimeWindows,
        isFlexibleDelivery: data.displayTimeWindows || false,
        metadata: {
          first_time_slot_available: `${firstTimeWindowDate.date} ${firstTimeWindowTime.time}`,
          delivery_type: firstTimeWindow.activityType.toLowerCase(),
          vin_etching_applied: vinEtchingState
        }
      };
    }

    return undefined;
  } catch (err) {
    return Promise.reject(err instanceof Error ? err : new Error(String(err)));
  }
};

export const selectTimeSlotDate = (
  dispatch: React.Dispatch<TransferScheduleAction>,
  date: string
) => {
  dispatch({
    type: 'SELECT_DATE',
    payload: { date }
  });
};

export const selectTimeSlotTime = (
  dispatch: React.Dispatch<TransferScheduleAction>,
  timeSlot: TimeSlotData
) => {
  dispatch({
    type: 'SELECT_TIME',
    payload: {
      activityType: timeSlot.activityType,
      endRange: timeSlot.endRange ?? '',
      optionId: timeSlot.optionId,
      routeId: timeSlot.routeId,
      time: timeSlot.time,
      utcStartTime: timeSlot.utcStartTime
    }
  });
};

export const declineVinEtching = async (_dispatch: React.Dispatch<TransferScheduleAction>) => {
  try {
    await declineVinEtchingApi();
  } catch (err) {
    return Promise.reject(err instanceof Error ? err : new Error(String(err)));
  }
};
